import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { DossierSandboxService } from '@sc/data-access-state-management';
import { AuthService } from '@sc/feature-auth-okta';
import { InsurerRouterService } from '@sc/feature-insurer-path-router-system';
import { DeclarationConditions } from '@sc/utils';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

export const SinisterDataFormGuardCanActivate: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const dossierSB = inject(DossierSandboxService);
  const router = inject(Router);
  const authService = inject(AuthService);
  const insurerRouterService = inject(InsurerRouterService);
  const declarationConditions = inject(DeclarationConditions);

  const dossierNumberExists = !!authService.getCurrentDossierId();
  return combineLatest([
    dossierSB.dossier$,
    insurerRouterService.getRedirectRoute(),
  ]).pipe(
    map(([dossier, redirectUrl]) => {
      return dossierNumberExists &&
        dossier?.customer &&
        declarationConditions.canEditB2BDossierAfterApiCreation(dossier)
        ? true
        : router.parseUrl(redirectUrl);
    })
  );
};
